import React from 'react'

const CinemaIcon = ({
    cinemaData
}) => {
    if(!cinemaData) {
        return ''
    }

    const {
        cinemaColor,
        cinemaIcon
    } = cinemaData.scope

    const colorStyle = {
        backgroundColor: cinemaColor ? cinemaColor : 'transparent'
    }

    const iconStyle = {
        backgroundImage: cinemaIcon ? `url(${cinemaIcon})` : 'none'
    }

    return (
        <div className="cinema-icon-wrapper" style={colorStyle}>
            <div className="cinema-icon" style={iconStyle}/>
        </div>
    )
   
}

export default CinemaIcon   